/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import React from 'react'

const Menu = props => {
  return (
    <div>
      <button
        className={
          props.showMenu
            ? ' menu_icon open styleMenuOpen'
            : 'menu_icon styleMenuCLose'
        }
        onClick={() => props.triggerMenu()}
      >
        <span className='sr-only'>Menu</span>
      </button>
      {props.showMenu && (
        <>
          <div
            onClick={() => props.triggerMenu()}
            className='menu-overlay'
          ></div>
          <div id='menu'>
            <ul>
              <li className='active'>
                <a href='https://m.airtkt.com/'>Flights</a>
              </li>
              <li>
                <a href='http://hotel.airtkt.com'>Hotels</a>
              </li>
              <li>
                <a href='https://www.airtkt.com/car_rental.php'>Cars</a>
              </li>
              <li>
                <a href='https://www.airtkt.com/last_minute_travel.php'>
                  Last Minute
                </a>
              </li>
              <li>
                <a href='https://www.airtkt.com/book/travelex/'>Insurance</a>
              </li>
              <li>
                <a href='https://www.airtkt.com/book/support/category.php?cat=sup'>
                  AirTkt Guide
                </a>
              </li>
              <li>
                <a href='https://www.airtkt.com/book/support/category.php?cat=cu'>
                  Contact Us
                </a>
              </li>
              <li>
                <a href='https://www.airtkt.com/my-world/'>My World</a>
              </li>
            </ul>
          </div>
        </>
      )}
    </div>
  )
}

export default Menu
